<template>
  <ModalVue
      :fields="[
      {
        name: 'firstname',
        type: 'text',
        tag: 'input',
        placeholder: 'imię',
        req: true,
        value: firstName,
        label: 'imię'
      },
      {
        name: 'lastname',
        type: 'text',
        tag: 'input',
        placeholder: 'nazwisko',
        req: true,
        value: lastName,
        label: 'nazwisko'
      },
      {
        name: 'phone',
        type: 'tel',
        tag: 'input',
        placeholder: 'numer telefonu',
        req: true,
        htmlPattern: '[0-9]{9}',
        value: phone,
        label: 'numer telefonu'
      },
      {
        name: 'state',
        tag: 'select',
        options: states,
        value: state_id,
        label: 'województwo'
      },
      {
        name: 'address',
        type: 'text',
        tag: 'input',
        placeholder: 'adres',
        req: false,
        value: address,
        label: 'adres'
      },
      {
        name: 'category',
        tag: 'select',
        options: categories,
        value: category_id,
        label: 'kategoria'
      }
    ]"
      title="edytuj dane"
      button-text="zatwierdź"
      :isVisible="isModalVisible"
      @closeModal="() => { isModalVisible = false; }"
      @sendData="(data) => editUser(data)"
  />

  <ModalVue
      :fields="[
      {
        name:'photo',
        type:'file',
        tag: 'input',
        req: true
      }
    ]"
      title="prześlij zdjęcie"
      button-text="wyślij"
      :is-visible="isPhotoModalVisible"
      @closeModal="() => { isPhotoModalVisible = false; }"
      @sendData="(data) => sendPhoto(data)"
  />

  <div v-if="currentUser" class="user-data-page">
    <div class="page-header">
      <h1>Twoje dane</h1>
      <button class="btn-outline" @click="() => isModalVisible = true">
        Edytuj dane
      </button>
    </div>

    <div class="layout" v-if="currentUser.role_id === 4">
      <section class="section-card profile-card">
        <div class="avatar-actions">
          <button
              class="avatar-btn"
              @click="() => {
              if (!userPhotoUrl) {
                isPhotoModalVisible = true;
              } else {
                removePhoto();
              }
            }"
          >
            <img class="avatar-btn__img" :src="userPhotoUrl ? userPhotoUrl : getImageUrl()" alt="zdjęcie profilowe">
            <img
                class="avatar-btn__icon"
                :src="userPhotoUrl ? require('@/assets/icons/trash.svg') : require('@/assets/icons/pencil-square.svg')"
                alt="akcja zdjęcia"
            >
          </button>
        </div>

        <div class="identity">
          <h2>{{ firstName }} {{ lastName }}</h2>
          <p>{{ email }}</p>
        </div>

        <div class="meta-list">
          <div class="meta-item">
            <span class="meta-item__label">Adres</span>
            <span :class="['meta-item__value', { 'no-value': !address }]">{{ address ? address : 'brak adresu' }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-item__label">Telefon</span>
            <span :class="['meta-item__value', { 'no-value': !phone }]">{{ phone ? phone : 'brak numeru telefonu' }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-item__label">Kategoria</span>
            <span :class="['meta-item__value', { 'no-value': !category }]">{{ category ? category.name : 'brak kategorii' }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-item__label">Województwo</span>
            <span :class="['meta-item__value', { 'no-value': !state }]">{{ state ? state.name : 'brak województwa' }}</span>
          </div>
        </div>

        <button class="btn-primary full-width" @click="() => $router.push(`/browse/user/${currentUser.id}`)">
          Twoja wizytówka
        </button>
      </section>

      <section class="section-card descriptions-card">
        <div class="section-card-header">
          <h2>Opisy działalności</h2>
        </div>

        <form class="descriptions-form" @submit="(e) => sendDescriptions(e)">
          <label for="shortDescription">Krótki opis działalności</label>
          <textarea
              name="shortDescription"
              id="shortDescription"
              v-model="short_description"
              required
              maxlength="350"
              minlength="20"
          ></textarea>

          <label for="description">Opis działalności</label>
          <textarea
              name="description"
              id="description"
              v-model="description"
              required
              maxlength="3000"
              minlength="80"
          ></textarea>

          <div class="form-actions">
            <button type="submit" class="btn-green">Zatwierdź</button>
          </div>
        </form>
      </section>
    </div>
  </div>

  <div v-else class="section-card loading-state">
    <h2>Błąd wczytywania. Spróbuj ponownie</h2>
  </div>
</template>

<script>
import ModalVue from '@/components/Modal.vue';
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'EmployeeProfileUserData',
  components: { ModalVue },
  data() {
    return {
      userPhotoUrl: '',
      userPhotoId: '',
      firstName: '',
      lastName: '',
      email: '',
      isModalVisible: false,
      isPhotoModalVisible: false,
      address: '',
      description: '',
      short_description: '',
      phone: '',
      category: null,
      category_id: null,
      state: null,
      state_id: null,
      states: [],
      categories: []
    };
  },
  setup() {
    useMeta({ title: 'twoje dane' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore()
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 4) {
      this.$router.push('/login');
    }
    this.getUserData();
  },
  methods: {
    getImageUrl() {
      return new URL(`../../assets/photo-placeholder.png`, import.meta.url).href;
    },
    getUserData() {
      axios.get(`/User/${this.currentUser.id}`).then((res) => {
        this.firstName = res.data.firstname;
        this.lastName = res.data.lastname;
        this.email = res.data.email;
        this.address = res.data.address;
        this.description = res.data.description;
        this.short_description = res.data.short_description;
        this.phone = res.data.phone;
        this.category = res.data.category;
        this.category_id = res.data.category.id;
        this.state = res.data.state;
        this.state_id = res.data.state.id;
      });

      axios.get(`/UserImage/${this.currentUser.id}`).then((res) => {
        if (res.data.length > 0) {
          this.userPhotoUrl = res.data[0].photo_url;
          this.userPhotoId = res.data[0].id;
        }
      });

      axios.get('/State').then((res) => {
        this.states = [];
        res.data.forEach((item) => {
          this.states.push({
            name: item.name,
            value: `${item.id}`
          });
        });
      });

      axios.get('/Categories').then((res) => {
        this.categories = [];
        res.data.forEach((item) => {
          this.categories.push({
            name: item.name,
            value: `${item.id}`
          });
        });
      });
    },
    editUser(data) {
      axios.post('/UserProfile', {
        id: this.currentUser.id,
        firstname: data.firstname,
        lastname: data.lastname,
        email: this.email,
        name: data.businessName,
        phone: data.phone,
        category_id: data.category,
        state_id: data.state,
        address: data.address,
        description: this.description,
        short_description: this.short_description
      }, authHeader()).then((res) => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano dane');
          this.firstName = data.firstname;
          this.lastName = data.lastname;
          this.phone = data.phone;
          this.category = this.categories.find((cat) => cat.value == data.category);
          this.state = this.states.find((state) => state.value == data.state);
          this.address = data.address;
        }
      });
    },
    sendPhoto(data) {
      axios.post('/UserImage', {
        user_id: this.currentUser.id,
        photo: data.photo
      }, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then((res) => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie dodano zdjęcie');
          this.userPhotoUrl = URL.createObjectURL(data.photo);
        }
      });
    },
    removePhoto() {
      axios.delete(`/UserImage/${this.userPhotoId}`, authHeader()).then((res) => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto zdjęcie');
          this.userPhotoUrl = '';
        }
      }).catch(() => {
        setTimeout(() => {
          location.reload();
        }, 500);
      });
    },
    sendDescriptions(e) {
      e.preventDefault();
      axios.post('/UserProfile', {
        id: this.currentUser.id,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        name: this.businessName,
        phone: this.phone,
        category_id: this.category,
        state_id: this.state,
        address: this.address,
        description: this.description,
        short_description: this.short_description
      }, authHeader()).then((res) => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano opisy');
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.user-data-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
}

.layout {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 20px;
  box-sizing: border-box;
}

.profile-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.avatar-actions {
  display: flex;
  justify-content: center;
}

.avatar-btn {
  width: 120px;
  height: 120px;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  border-radius: 999px;
  position: relative;
}

.avatar-btn__img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #e5e7eb;
}

.avatar-btn__icon {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 2px;
  bottom: 2px;
  background: #fff;
  border-radius: 999px;
  padding: 4px;
  border: 1px solid #d1d5db;
}

.identity {
  text-align: center;
}

.identity h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.identity p {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 1.4rem;
  word-break: break-word;
}

.meta-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.meta-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 10px;
}

.meta-item__label {
  display: block;
  color: #6b7280;
  font-size: 1.2rem;
  margin-bottom: 2px;
}

.meta-item__value {
  color: #1f2937;
  font-size: 1.4rem;
}

.no-value {
  color: #9ca3af;
}

.full-width {
  width: 100%;
}

.section-card-header h2 {
  margin: 0 0 16px;
  font-size: 2rem;
  color: #1f2937;
}

.descriptions-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.descriptions-form label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.descriptions-form textarea {
  width: 100%;
  min-height: 120px;
  resize: vertical;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
}

.descriptions-form textarea:focus {
  border-color: #10b981;
}

.form-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary,
.btn-green,
.btn-outline {
  border-radius: 8px;
  border: none;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-primary {
  background: #f97316;
  color: #fff;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-green {
  background: #10b981;
  color: #fff;
}

.btn-green:hover {
  background: #059669;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.loading-state {
  max-width: 900px;
  margin: 24px auto;
  text-align: center;
}

@media (max-width: 960px) {
  .layout {
    grid-template-columns: 1fr;
  }

  .form-actions {
    justify-content: flex-start;
  }
}

@media (max-width: 480px) {
  .user-data-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .btn-outline,
  .btn-primary,
  .btn-green {
    width: 100%;
    text-align: center;
  }
}
</style>